export default __webpack_public_path__ + "static/media/logo_de_white.07903924.svg";